
import request from '@/request'
const part_url = '/recruit/employee/';

function getUserInfo(data) {
  let url = part_url + "getUserInfo";
  return request.get(url, data)
}
function getSignInfo(data) {
  let url = part_url + "getSignInfo";
  return request.get(url, data)
}

function updateUserInfo(data) {
  let url = part_url + "updateUserInfo";
  return request.post(url,{}, data)
}

function getResume(){
  let url = part_url + "getResume";
  return request.get(url,{})
}
function checkResume(data){
  let url = part_url + "checkResume";
  return request.get(url,data)
}


export default {
    getUserInfo,
    updateUserInfo,
    getResume,
    checkResume,
    getSignInfo
  }


// WEBPACK FOOTER //
// ./src/api/employee.js